import logo from './logo-light 1.svg';
import { useState } from 'react';
import './nav.css';
import insta from './68d99ba29cc8.png'
import web from './web.png';

const Nav = () => {
    const [modal,viewModal] = useState(false);
    const [animationStyle,startAnim] = useState({});
    const anst = {
        animationName:'view',
        animationDuration:'2s',
    }
    const handleClick = () => {
        viewModal(true);
        startAnim(anst);
    }
    const handleClick2 = () => {
        viewModal(false);
    }

    return ( 
        <>
            <div className="nav">
                <a href="http://www.siamvit.in/"><img src ={logo} alt=""/></a>
                <button className="nav-link" onClick={handleClick}>Follow Us</button>
            </div>
            {modal && 
                <div className="Modal">
                    <div className="modal-inner" style={animationStyle}>
                        <button onClick={handleClick2}>X</button>
                        <h3>Follow at:</h3><br/>
                        <p><a href="https://www.instagram.com/siamvit/"><img className="mimag" alt="" src={insta}/>@siamvit</a></p>
                        <p><a href="http://www.siamvit.in/"><img className="mimag" alt="" src={web}/>Siamvit.in</a></p>
                    </div>
                </div>
            }
        </>
     );
}
 
export default Nav;